import { Button } from "@repo/ui/core";
import { useAnalytics } from "../analytics";

/**
 * Analytics consent notice, bottom-left so it never covers toasts. Analytics
 * is opt-in: nothing is loaded or sent until "Accept" is chosen. Accept and
 * Decline are deliberately identical so neither choice is visually favoured.
 * Shows on first visit and whenever reopened from "Privacy settings".
 */
export function CookieConsent() {
  const { bannerOpen, consent, setConsent, analytics, monitoring } =
    useAnalytics();
  if (!bannerOpen) return null;

  return (
    <div
      role="region"
      aria-label="Analytics consent"
      style={{
        position: "fixed",
        left: 16,
        bottom: 16,
        zIndex: 210,
        width: "min(420px, calc(100vw - 32px))",
        display: "flex",
        flexDirection: "column",
        gap: 12,
        padding: "14px 16px",
        background: "var(--na-surface)",
        border: "1px solid var(--na-border)",
        boxShadow: "var(--na-shadow-xl)",
        animation: "naFadeUp 220ms var(--na-ease-standard)",
      }}
    >
      <div style={{ fontSize: 13, fontWeight: 500 }}>Help us improve this console?</div>
      <div style={{ fontSize: 12, lineHeight: "18px", color: "var(--na-fg-dimmed)" }}>
        {analytics &&
          "With your consent we collect product improvement analytics: usage events (such as pages viewed and left, and onboarding steps), where on a page you click and how far you scroll, a pseudonymous ID, and browser and device information, sent to our analytics service (PostHog). "}
        {monitoring &&
          `${analytics ? "We also collect" : "With your consent we collect"} error and performance monitoring: JavaScript errors, page load timings, and browser and device information, sent to our monitoring service (Grafana Faro). `}
        For customer deployments these services run inside the
        deployment&apos;s own cloud account. We do not collect email addresses
        or the content you work with. How long data is kept is set by the
        operator&apos;s retention policy. Nothing is collected unless you
        accept, and you can change your choice at any time via &quot;Privacy
        settings&quot;.
        {consent === null
          ? ""
          : ` Current choice: ${consent === "accepted" ? "accepted" : "declined"}.`}
      </div>
      <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
        <Button h={30} fz={12} onClick={() => setConsent("declined")}>
          Decline
        </Button>
        <Button h={30} fz={12} onClick={() => setConsent("accepted")}>
          Accept
        </Button>
      </div>
    </div>
  );
}
